import React, { memo, useMemo, useCallback } from 'react';
import IconMC from '../../../components/IconMC';
import { isWhatsAppMsPlatform } from '../../../../services/inbox/inboxMsChatPlatform';

/**
 * MessageStatusIconMC - Atom-level component
 * Muestra el icono de estado del mensaje según plataforma y status.
 * Optimizado con useMemo y useCallback para evitar renders innecesarios.
 */
const MessageStatusIconMC = memo(({ message, platform }) => {
  // Memoiza el nombre y color del icono según el estado del mensaje
  const iconProps = useMemo(() => {
    switch (message.status) {
      case 'sent':
        return { name: 'checkmark-outline', size: 'xs', className: 'tw-fill-gray-300 tw-ml-0.5' };
      case 'delivered':
        return { name: 'double-check-outline', size: 'xs', className: 'tw-fill-gray-300 tw-ml-0.5' };
      case 'read':
        return { name: 'double-check-outline', size: 'xs', className: 'tw-fill-blue-500 tw-ml-0.5' };
      // 'failed' llega del webhook asíncrono de Meta y 'error' del fallo
      // síncrono de envío. Sin estos casos ambos caían en el default y pintaban
      // el mismo check gris que un mensaje entregado.
      case 'failed':
      case 'error':
        return { name: 'alert-circle-fill', size: 'xs', className: 'tw-fill-red-500 tw-ml-0.5' };
      default:
        return { name: 'checkmark-outline', size: 'xs', className: 'tw-fill-gray-300 tw-ml-0.5' };
    }
  }, [message.status]);

  // Memoiza el renderizado del icono para WhatsApp y otras plataformas
  const renderIcon = useCallback(() => {
    if (isWhatsAppMsPlatform(platform)) {
      const { name, size, className } = iconProps;
      return <IconMC name={name} size={size} className={className} />;
    }
    // Para otras plataformas, solo muestra el icono si no hay error
    return !message.errorMessage
      ? <IconMC name="double-check-outline" size="xs" className="tw-fill-blue-500 tw-ml-0.5" />
      : null;
  }, [platform, iconProps, message.errorMessage]);

  return renderIcon();
});

MessageStatusIconMC.displayName = 'MessageStatusIconMC';

export default MessageStatusIconMC;
